// extracted by mini-css-extract-plugin
module.exports = {"defaultLayout":"Step_defaultLayout__uSKGD","withIconLayout":"Step_withIconLayout__xcHOA"};